import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify'; 
import ReactLoading from 'react-loading';
import api from '../../../hooks/api';

// تابع نرمال‌سازی شماره برای مقایسه دقیق
const normalizePhone = (phone) => {
    if (!phone) return "";
    let p = String(phone).trim();
    p = p.replace('+', '');
    if (p.startsWith('98')) p = p.substring(2);
    if (p.startsWith('0')) p = p.substring(1);
    return p;
};

const PhoneAccessComponent = ({ fn_phoneAccess, ChatId, isSendCode, isVerified }) => {

  const [isShared, setIsShared] = useState(null);
  
  // دکمه لودینگ دارد اگر درخواست شیر شده ولی هنوز کد ارسال نشده (در حال پولینگ)
  const isLoading = isShared && !isSendCode;
  
  // دکمه قفل است اگر: در حال لودینگ باشد یا تایمر کد فعال باشد
  const isButtonDisabled = isLoading || isSendCode;

  let interval = null;
  
  const fn_toggle = (value) => {
    if(interval) clearInterval(interval);
    setIsShared(false); 
    fn_phoneAccess(value);
  }

  // اگر والد تایید شد و پولینگ تمام شد، حالت شیر را ریست کن
  useEffect(() => {
     if(isVerified && isShared === null) {
         setIsShared(false);
     }
  }, [isVerified]);

  useEffect(() => {
    if (isLoading) {
      // شروع Polling
      interval = setInterval(async () => {
        try {
          const response = await api.post(`user/find`);
          if (response.status === 200) {
            const data = response.data.data;
            const mobileTemp = data.mobile_Temp;
            const currentMobile = data.mobile;

            if (mobileTemp != null) {
                const normTemp = normalizePhone(mobileTemp);
                const normCurrent = normalizePhone(currentMobile);

                // شرط تشخیص تکراری بودن:
                // 1. سرور مقدار -1 برگرداند
                // 2. یا شماره نرمال شده Temp با شماره فعلی برابر باشد
                if (String(mobileTemp) === '-1' || normTemp === normCurrent) {
                    
                    if(interval) clearInterval(interval);
                    setIsShared(false); // توقف لودینگ
                    
                    // نمایش پیام با Z-Index بالا
                    toast.info("این شماره قبلاً برای شما ثبت شده است.", {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "light",
                        rtl: true,
                        style: { zIndex: 99999999 } 
                    });

                    // ریست کردن استیت در والد (بدون تغییر شماره)
                    fn_phoneAccess(null); 
                } 
                // اگر شماره جدید است
                else {
                    fn_toggle(data);
                }
            }
          }
        } catch (error) {
          console.error('API Error:', error);
        }
      }, 5000);

      // تایم‌اوت کلی 30 ثانیه برای توقف تلاش
      setTimeout(() => {
        if (interval) {
            clearInterval(interval);
            setIsShared(false); 
            interval = null;
        }
      }, 30000);
    }
    
    return () => {
        if (interval) clearInterval(interval);
    };
  }, [isShared, ChatId, isLoading]); 

  const handleRequestPhone = async () => {
    try {
      const version = parseFloat(window.Telegram.WebApp.version || '0');
      if (version < 6.1) {
        toast.error("نسخه تلگرام شما قدیمی است.", { position: "top-left" });
      } else {
        const shared = await requestPhoneAccess();
        // اگر کاربر دسترسی داد، وارد حالت لودینگ می‌شویم
        if(shared) setIsShared(true);
      }
    } catch (err) {
        console.error(err);
        setIsShared(false);
    }
  };

  return (
    <>
      <div 
        className={`btn-mobile ${isButtonDisabled ? 'disabled' : ''}`} 
        onClick={() => {
          // فقط اگر دکمه فعال است اجازه کلیک بده
          if (!isButtonDisabled) {
            handleRequestPhone()
          }
        }}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
      >
        <span>
            {/* متن دکمه بر اساس وضعیت */}
            {isVerified ? 'تایید شده (تغییر شماره)' : 'تایید شماره همراه'}
        </span>
        
        {/* لودینگ دایره‌ای کنار متن */}
        {isLoading && (
          <ReactLoading type={"spin"} color={"#FFFFFF"} height={20} width={20} />
        )}
      </div>
    </>
  );
};

async function requestPhoneAccess() {
  return new Promise((resolve) => {
    if (!window.Telegram?.WebApp?.requestContact) {
      resolve(null);
      return null;
    }
    window.Telegram.WebApp.requestContact((isShared) => {
      resolve(isShared);
    });
  });
}

export default PhoneAccessComponent;
